import { Stack } from "@mui/material";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import type { UserAdminDetailDto } from "Infrastructure/Api/Api";
import { AccountSection } from "Components/Users/UserDetailPageContent/Components/UserReadOnlyDetail/AccountSection";
import { VerificationSection } from "Components/Users/UserDetailPageContent/Components/UserReadOnlyDetail/VerificationSection";
import { BankSection } from "Components/Users/UserDetailPageContent/Components/UserReadOnlyDetail/BankSection";
import { LimitsSection } from "Components/Users/UserDetailPageContent/Components/UserReadOnlyDetail/LimitsSection";
import { ProgramParticipationSection } from "Components/Users/UserDetailPageContent/Components/ProgramParticipationSection";

type Props = {
  user: UserAdminDetailDto;
};

export const UserReadOnlyDetail = ({
  user: {
    login,
    status,
    verificationAdditionalInfoStatus,
    verificationIdentityVerificationStatus,
    verificationRiskProfile,
    verificationBankVerificationStatus,
    bankVerificationSource,
    verifiedIBAN,
    verificationDailyBuyLimit,
    verificationMonthlyBuyLimit,
    stardustParticipation,
    thanksToYouParticipation,
  },
}: Props) => (
  <PrimaryPaper>
    <Stack gap={4}>
      <AccountSection login={login} status={status} />
      <VerificationSection
        verificationAdditionalInfoStatus={verificationAdditionalInfoStatus}
        verificationIdentityVerificationStatus={
          verificationIdentityVerificationStatus
        }
        verificationRiskProfile={verificationRiskProfile}
        verificationBankVerificationStatus={verificationBankVerificationStatus}
      />
      <BankSection
        bankVerificationSource={bankVerificationSource}
        verifiedIBAN={verifiedIBAN}
      />
      <LimitsSection
        verificationDailyBuyLimit={verificationDailyBuyLimit}
        verificationMonthlyBuyLimit={verificationMonthlyBuyLimit}
      />
      <ProgramParticipationSection
        participation={stardustParticipation}
        noMargins
      />
      <ProgramParticipationSection
        participation={thanksToYouParticipation}
        noMargins
      />
    </Stack>
  </PrimaryPaper>
);
